import { NSARouterMakerResult } from "namirasoft-account-react";
import { EncodingOperation, EnvService, URLOperation } from "namirasoft-core";
import { NSBanner, NSButtonBlue, NSPanel } from "namirasoft-site-react";

import { DonateLayout } from "../DonateLayout";
import { DonateRouterProps } from "../DonateRouterProps";
import { DonateRoutes } from "../DonateRoutes";

interface DonatePageProps extends NSARouterMakerResult, DonateRouterProps { }

interface ImpactCardProps
{
    icon: string;
    title: string;
    description: string;
    accent: string;
}

function ImpactCard(props: ImpactCardProps)
{
    return (
        <div
            style={{
                flex: "1 1 260px",
                minWidth: "260px",
                background: "#ffffff",
                borderRadius: "16px",
                padding: "28px 24px",
                boxShadow: "0 4px 20px rgba(20, 27, 92, 0.08)",
                border: "1px solid rgba(20, 27, 92, 0.06)",
                display: "flex",
                flexDirection: "column",
                gap: "12px"
            }}
        >
            <div
                style={{
                    width: "52px",
                    height: "52px",
                    borderRadius: "14px",
                    background: props.accent,
                    color: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "26px",
                    fontWeight: 700
                }}
            >
                {props.icon}
            </div>
            <div
                style={{
                    fontSize: "18px",
                    fontWeight: 700,
                    color: "rgba(20, 27, 92, 1)"
                }}
            >
                {props.title}
            </div>
            <div
                style={{
                    fontSize: "14px",
                    lineHeight: 1.6,
                    color: "rgba(20, 27, 92, 0.72)"
                }}
            >
                {props.description}
            </div>
        </div>
    );
}

function DonatePage(props: DonatePageProps)
{
    const getPaymentLink = () =>
    {
        let REACT_APP_BASE_URL_PAYMENT_CONSOLE = new EnvService("REACT_APP_BASE_URL_PAYMENT_CONSOLE", true).getString();

        return URLOperation.getLink(
            REACT_APP_BASE_URL_PAYMENT_CONSOLE,
            "offer/donate/membership/pym-ofr-ebb3bc342b97/gateway",
            {
                gateway: "stripe",
                callback: EncodingOperation.Base64Encode(window.location.origin + props.url.getLink(DonateRoutes.DonateSuccess, {}))
            }
        );
    };

    const onClick = () =>
    {
        try
        {
            const paymentLink = getPaymentLink();
            window.open(paymentLink, "_blank", "noopener,noreferrer");
        }
        catch (error)
        {
            props.notifier.onError(error as Error);
        }
    };

    return (
        <DonateLayout
            {...props}
            action={{
                title: "Donate",
                menus: {}
            }}
        >
            <div>
                <div
                    style={{
                        background: "linear-gradient(135deg, rgba(20, 27, 92, 0.04) 0%, rgba(76, 111, 255, 0.06) 100%)",
                        padding: "48px 24px",
                        borderRadius: "24px",
                        marginBottom: "32px"
                    }}
                >
                    <NSBanner
                        imageLeft={{
                            src: "https://static.namirasoft.com/image/concept/bot/payment-successful.png",
                            alt: "Support Namirasoft"
                        }}
                        imageRight={null}
                        headline={{
                            text: "Support Our Mission",
                            style: { color: "rgba(76, 111, 255, 1)", fontWeight: 600, letterSpacing: "1px", textTransform: "uppercase" }
                        }}
                        title={{
                            text: "Help Us Keep Building",
                            style: { fontWeight: 800, lineHeight: 1.15 }
                        }}
                        description={{
                            text: "Namirasoft offers a growing family of free apps designed to make your work and life easier. Your generous support powers every update, every new feature, and every fix.",
                            style: { fontSize: "17px", lineHeight: 1.7 }
                        }}
                    />
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "48px"
                    }}
                >
                    <div style={{ width: "100%", maxWidth: "640px" }}>
                        <NSPanel>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    textAlign: "center",
                                    padding: "32px 24px",
                                    gap: "16px"
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "28px",
                                        fontWeight: 800,
                                        color: "rgba(20, 27, 92, 1)"
                                    }}
                                >
                                    Ready to Make a Difference?
                                </div>
                                <div
                                    style={{
                                        fontSize: "16px",
                                        color: "rgba(20, 27, 92, 0.75)",
                                        maxWidth: "560px",
                                        lineHeight: 1.7
                                    }}
                                >
                                    Choosing to donate is completely optional, and the amount is entirely your decision. Every donation, large or small, makes a meaningful difference to our team and the community we serve.
                                </div>
                                <div
                                    style={{
                                        fontSize: "14px",
                                        color: "rgba(20, 27, 92, 0.6)",
                                        maxWidth: "560px",
                                        lineHeight: 1.6,
                                        marginBottom: "8px"
                                    }}
                                >
                                    Click the button below and you will be directed to our secure payment gateway where you can enter the amount you wish to donate.
                                </div>
                                <NSButtonBlue
                                    title="Support Us"
                                    onClick={{ action: onClick, showLoading: false }}
                                    style={{
                                        marginTop: "8px",
                                        minWidth: "220px",
                                        fontSize: "16px",
                                        fontWeight: 700
                                    }}
                                />
                                <div
                                    style={{
                                        fontSize: "13px",
                                        color: "rgba(20, 27, 92, 0.55)",
                                        marginTop: "8px"
                                    }}
                                >
                                    Secure checkout powered by Stripe
                                </div>
                            </div>
                        </NSPanel>
                    </div>
                </div>

                <div
                    style={{
                        textAlign: "center",
                        marginBottom: "24px"
                    }}
                >
                    <div
                        style={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "rgba(76, 111, 255, 1)",
                            letterSpacing: "1px",
                            textTransform: "uppercase",
                            marginBottom: "8px"
                        }}
                    >
                        Where Your Donation Goes
                    </div>
                    <div
                        style={{
                            fontSize: "32px",
                            fontWeight: 800,
                            color: "rgba(20, 27, 92, 1)",
                            marginBottom: "12px"
                        }}
                    >
                        Every Contribution Makes an Impact
                    </div>
                    <div
                        style={{
                            fontSize: "16px",
                            color: "rgba(20, 27, 92, 0.7)",
                            maxWidth: "640px",
                            margin: "0 auto",
                            lineHeight: 1.6
                        }}
                    >
                        We put every dollar to work building better software and serving our community.
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                        marginBottom: "40px",
                        justifyContent: "center"
                    }}
                >
                    <ImpactCard
                        icon="+"
                        title="New Features"
                        description="Fund the research and engineering behind fresh capabilities that our users request every day."
                        accent="linear-gradient(135deg, #4C6FFF 0%, #7C3AED 100%)"
                    />
                    <ImpactCard
                        icon="~"
                        title="Ongoing Maintenance"
                        description="Keep our apps fast, secure, and reliable through continuous updates and infrastructure upgrades."
                        accent="linear-gradient(135deg, #10B981 0%, #14B8A6 100%)"
                    />
                    <ImpactCard
                        icon="*"
                        title="Community Support"
                        description="Help us stay free for everyone and expand access to the tools that make daily work easier."
                        accent="linear-gradient(135deg, #F59E0B 0%, #EF4444 100%)"
                    />
                </div>
            </div>
        </DonateLayout>
    );
}

export default DonatePage;